import type {CommonProps} from './types';

const SearchItems = ({
  color = 'currentColor',
  size = 12,
  ...rest
}: CommonProps) => (
  <svg
    aria-hidden="true"
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M31.5 9.25a6.25 6.25 0 1012.5 0 6.25 6.25 0 00-12.5 0v0zM42.17 13.67L46.5 18M25.5 15h-21a3 3 0 01-3-3V9a3 3 0 013-3h21M5.25 22.5a.75.75 0 110 1.5.75.75 0 010-1.5zM12 24h24M5.25 33a.75.75 0 110 1.5.75.75 0 010-1.5zM12 34.5h24M5.25 43.5a.75.75 0 110 1.5.75.75 0 010-1.5zM12 45h24"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SearchItems;
